import { render, staticRenderFns } from "./reception.vue?vue&type=template&id=6d040900&scoped=true&"
import script from "./reception.vue?vue&type=script&lang=js&"
export * from "./reception.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d040900",
  null
  
)

export default component.exports